window.Formatters = {
    currency: (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val),
    percentage: (val) => new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1 }).format(val / 100),
    number: (val) => new Intl.NumberFormat('pt-BR').format(val),
    default: (val) => val
};
